var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpersonateEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye_icon",
    "data-name": "eye icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18035",
    "data-name": "Rectangle 18035",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "viewer",
    transform: "translate(2.935 4.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11711",
    "data-name": "Group 11711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11710",
    "data-name": "Group 11710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12760",
    "data-name": "Path 12760",
    d: "M168.487,274a2.484,2.484,0,1,0,2.484,2.484A2.487,2.487,0,0,0,168.487,274Zm0,3.864a1.38,1.38,0,1,1,1.38-1.38A1.381,1.381,0,0,1,168.487,277.864Z",
    transform: "translate(-161.487 -267.967)",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12761",
    "data-name": "Path 12761",
    d: "M13.942,65.2a7.305,7.305,0,0,0-2.765-2.982l1.48-1.508a.564.564,0,0,0,0-.788.54.54,0,0,0-.773,0l-1.737,1.769a8.063,8.063,0,0,0-2.6-.612V58.557a.547.547,0,1,0-1.094,0v2.524a8.063,8.063,0,0,0-2.6.612L2.117,59.925a.54.54,0,0,0-.773,0,.564.564,0,0,0,0,.788l1.48,1.508A7.305,7.305,0,0,0,.059,65.2.562.562,0,0,0,.3,65.95a.542.542,0,0,0,.735-.246A6.6,6.6,0,0,1,7,62.177,6.6,6.6,0,0,1,12.965,65.7a.542.542,0,0,0,.735.246A.562.562,0,0,0,13.942,65.2Z",
    transform: "translate(0 -58)",
    fill: "#455079"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpersonateEye);
export default __webpack_public_path__ + "static/media/impersonate-eye.31fd83e407e588bd26ade04b0f06cba1.svg";
export { ForwardRef as ReactComponent };